import { type Key, useState } from 'react';
import { Modal, Tree, type TreeProps } from 'antd';
import { DownOutlined } from '@ant-design/icons';

import type { TreeModalProps } from './TreeModal.types';
import { useTranslation } from 'react-i18next';

export default function ResponsibilitiesModal({
  open,
  selected,
  treeData,
  onClose,
  onSubmit,
  expandedKeys,
  onExpand,
  title,
  isNumber,
}: TreeModalProps) {
  const [checkedList, setCheckedList] = useState<Key[]>(selected.map((item) => item.toString()));
  const { t } = useTranslation();
  const handleSubmit = () => {
    onSubmit(checkedList.map((item) => item.toString()));
    onClose();
  };
  const handleCancel = () => {
    onClose();
  };
  const handleExpand = (keys: Key[]) => {
    onExpand(keys);
  };

  const onCheck: TreeProps['onCheck'] = (checkedKeys) => {
    const keys = Array.isArray(checkedKeys) ? checkedKeys : checkedKeys.checked;
    setCheckedList(keys);
  };
  const onSelect: TreeProps['onSelect'] = (selectedKeys) => {
    console.log('selected', selectedKeys);
    setCheckedList(selectedKeys);
  };
  return (
    <>
      <Modal
        title={title || ''}
        open={open}
        onOk={handleSubmit}
        onCancel={handleCancel}
        cancelText={t('common.cancel')}
        okText={t('common.confirm')}
      >
        <Tree
          checkable
          selectable={false}
          multiple
          checkedKeys={isNumber ? checkedList.map(Number) : checkedList}
          onCheck={onCheck}
          onSelect={onSelect}
          expandedKeys={expandedKeys}
          onExpand={handleExpand}
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-expect-error
          treeData={treeData}
          switcherIcon={<DownOutlined />}
        />
      </Modal>
    </>
  );
}
